import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { getSpeakers } from 'src/common/services/speakers';

export function useSpeakersFiltersQuery() {
  return useQuery([QueryKey.SpeakersFilters], (ctx) => getSpeakers({ ...ctx, pageSize: 100 }));
}
